(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ht-footer"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.__htFooterHeadingAlignment) return;
    window.__htFooterHeadingAlignment = true;
    const tablet = window.matchMedia('(min-width: 768px) and (max-width: 1100px)');
    const columnsByElement = new Map();
    let frame = null;
    const headingTextRect = (heading) => {
      const range = document.createRange();
      range.selectNodeContents(heading);
      return range.getBoundingClientRect();
    };
    const updateFooterHeadings = () => {
      frame = null;
      const active = [];
      columnsByElement.forEach((nodes, columns) => {
        if (!columns.isConnected) {
          observer?.unobserve(columns);
          columnsByElement.delete(columns);
          return;
        }
        if (nodes.customer.style.transform) nodes.customer.style.transform = '';
        if (tablet.matches) active.push(nodes);
      });
      const positions = active.map(({ companyHeading, customer, customerHeading, policyHeading }) => {
        const companyRect = headingTextRect(companyHeading);
        const customerRect = headingTextRect(customerHeading);
        const policyRect = headingTextRect(policyHeading);
        const leftGap = customerRect.left - companyRect.right;
        const rightGap = policyRect.left - customerRect.right;
        return { customer, shift: (rightGap - leftGap) / 2 };
      });
      positions.forEach(({ customer, shift }) => {
        customer.style.transform = `translateX(${shift}px)`;
      });
    };
    const scheduleUpdate = () => {
      if (frame === null) frame = requestAnimationFrame(updateFooterHeadings);
    };
    const observer = window.ResizeObserver ? new ResizeObserver(scheduleUpdate) : null;
    const initialize = () => {
      document.querySelectorAll('.hf-columns').forEach((columns) => {
        if (columnsByElement.has(columns)) return;
        const companyHeading = columns.querySelector('.hf-company h3');
        const customer = columns.querySelector('.hf-customer');
        const customerHeading = columns.querySelector('.hf-customer h3');
        const policyHeading = columns.querySelector('.hf-policy h3');
        if (!companyHeading || !customer || !customerHeading || !policyHeading) return;
        columnsByElement.set(columns, { companyHeading, customer, customerHeading, policyHeading });
        observer?.observe(columns);
      });
      scheduleUpdate();
    };
    initialize();
    window.addEventListener('resize', scheduleUpdate, { passive: true });
    document.addEventListener('shopify:section:load', initialize);
    document.addEventListener('shopify:section:unload', scheduleUpdate);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(scheduleUpdate);
  })();

  } catch(e) { console.error(e); }
})();
})();
